import { Outlet, useNavigate, useSearchParams } from 'react-router-dom';
import { Tab, Tabs } from '@mui/material';
import { FormattedMessage } from 'react-intl';
import { useRouteMatch } from 'hooks/useRouteMatch';
import { PageHeader } from 'components/Layout/PageContainer';

interface ApiAccessTab {
  route: string;
  messageId: string;
  defaultMessage?: string;
}

const apiAccessTabs: ApiAccessTab[] = [
  {
    route: '/api/about',
    messageId: 'api_access.about_tab',
    defaultMessage: 'About',
  },
  {
    route: '/api/token/*',
    messageId: 'api_access.token_tab',
  },
  {
    route: '/api/documentation',
    messageId: 'api_access.documentation_tab',
    defaultMessage: 'Documentation',
  },
];

function ApiAccess() {
  const navigate = useNavigate();
  const { matchRoute } = useRouteMatch(apiAccessTabs);
  const currentSubPage = (matchRoute() ?? apiAccessTabs.find(t => t.route === '/api/about')) as ApiAccessTab;

  const [searchParams] = useSearchParams();

  const handleChange = (_event: unknown, newSubPagePath: string | null) => {
    if (newSubPagePath !== null) {
      const cleanPath = newSubPagePath.replace('/*', '');
      const params = searchParams.toString();
      navigate(`${cleanPath}${params ? `?${params}` : ''}`);
    }
  };

  return (
    <div className="max-w-none api-access">
      <PageHeader
        className="pt-0"
        tabs={
          <Tabs value={currentSubPage.route} onChange={handleChange}>
            {apiAccessTabs.map(tab => (
              <Tab
                key={tab.route}
                value={tab.route}
                label={<FormattedMessage id={tab.messageId} defaultMessage={tab.defaultMessage} />}
                className="hover:bg-denim-50"
              />
            ))}
          </Tabs>
        }
      />

      <div className="standard-page-container">
        <Outlet />
      </div>
    </div>
  );
}

export { ApiAccess };
